import { render, staticRenderFns } from "./HomeC.vue?vue&type=template&id=4b345ef1&"
import script from "./HomeC.vue?vue&type=script&lang=js&"
export * from "./HomeC.vue?vue&type=script&lang=js&"
import style0 from "./HomeC.vue?vue&type=style&index=0&id=4b345ef1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports